/* src/app/job-signoff-land-services/modals/job-signoff-land-delete-all/job-signoff-land-delete-all.component.scss */
/*# sourceMappingURL=job-signoff-land-delete-all.component.css.map */
